// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invResourceId } from './InvResource';
import { operatorId } from './Operator';
import { z } from 'zod';
export const invSterilizationAdditiveId = (z.number());
export const invSterilizationAdditive = z.object({
    id: invSterilizationAdditiveId,
    resource_id: invResourceId,
    label: z.string(),
    default_ml_per_kg: z.string(),
    display_order: z.number(),
    archived_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const invSterilizationAdditiveInitializer = z.object({
    id: invSterilizationAdditiveId.optional(),
    resource_id: invResourceId,
    label: z.string(),
    default_ml_per_kg: z.string(),
    display_order: z.number().optional(),
    archived_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const invSterilizationAdditiveMutator = z.object({
    id: invSterilizationAdditiveId.optional(),
    resource_id: invResourceId.optional(),
    label: z.string().optional(),
    default_ml_per_kg: z.string().optional(),
    display_order: z.number().optional(),
    archived_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=InvSterilizationAdditive.js.map